import React, { useState, useEffect } from "react";
import { FaTrash, FaUpload, FaList } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import API_BASE_URL from "../config";

export default function UploadDocument() {
  const navigate = useNavigate();
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileList, setFileList] = useState([]);

  const token = sessionStorage.getItem("token");

  // Fetch document types
  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    fetch(`${API_BASE_URL}/api/documents/all`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.status === 401) {
          alert("Session expired. Please log in again.");
          navigate("/");
        }
        return res.json();
      })
      .then((data) => setDocumentTypes(data))
      .catch((err) => console.error("Error fetching document types:", err));
  }, [navigate, token]);

  // Add file to list
  const handleAddFile = () => {
    if (!selectedType) return alert("Please select document type.");
    if (!selectedFile) return alert("Please select a file.");
    setFileList([...fileList, { type: selectedType, file: selectedFile }]);
    setSelectedFile(null);
    setSelectedType("");
  };

  // Remove file
  const handleRemoveFile = (index) => {
    const newList = [...fileList];
    newList.splice(index, 1);
    setFileList(newList);
  };

  // Submit all files
  const handleSubmitAll = async () => {
    if (fileList.length === 0) return alert("No files to submit.");

    const formData = new FormData();
    fileList.forEach((item) => {
      formData.append("files", item.file);
      formData.append("types", item.type);
    });

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/uploaddocuments/uploadmydocuments`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        }
      );

      if (res.ok) {
        alert("Documents uploaded successfully!");
        setFileList([]);
      } else if (res.status === 401) {
        alert("Session expired. Please log in again.");
        navigate("/");
      } else {
        const msg = await res.text();
        alert(msg);
      }
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  // Navigate to document list
  const handleViewList = () => {
    navigate("/viewdocuments");
  };

  return (
    <>
      <div className="fixed-top">
        <EmployeeNavbar />
      </div>

      <div
        className="container-fluid"
        style={{
          paddingTop: "120px",
          minHeight: "100vh",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div className="px-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="fw-semibold text-start mb-0">Upload Documents</h3>

            {/* ✅ List Button */}
            <button
              className="btn btn-outline-primary btn-sm d-flex align-items-center"
              onClick={handleViewList}
            >
              <FaList className="me-2" />
              List
            </button>
          </div>

          {/* Upload section */}
          <div
            className="card shadow-sm p-4 mb-4"
            style={{
              borderRadius: "12px",
              background: "#fff",
            }}
          >
            <div className="row g-3 align-items-center">
              <div className="col-md-3">
                <select
                  className="form-select form-select-sm"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  <option value="">Select Document Type</option>
                  {documentTypes.map((doc) => (
                    <option key={doc.id} value={doc.name}>
                      {doc.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <input
                  type="file"
                  className="form-control form-control-sm"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
              </div>

              <div className="col-md-2">
                <button
                  className="btn btn-primary btn-sm w-100 "
                  onClick={handleAddFile}
                >
                  <FaUpload className="me-2" /> Add File
                </button>
              </div>
            </div>
          </div>

          {/* File list */}
          {fileList.length > 0 && (
            <div
              className="card shadow-sm p-4"
              style={{
                borderRadius: "12px",
                background: "#fff",
              }}
            >
              <h6 className="fw-semibold text-start mb-3">Selected Files</h6>
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                }}
              >
                <ul className="list-group list-group-flush">
                  {fileList.map((item, index) => (
                    <li
                      key={index}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span className="text-start">
                        <span className="badge bg-primary me-2">
                          {item.type}
                        </span>
                        {item.file.name}
                      </span>
                      <button
                        className="btn btn-light btn-sm text-danger"
                        onClick={() => handleRemoveFile(index)}
                      >
                        <FaTrash />
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-3 text-start">
                <button
                  className="btn btn-success btn-sm px-4"
                  onClick={handleSubmitAll}
                >
                  Submit All
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
